import React from 'react';
import { useNavigate } from 'react-router-dom';
import snowdrop from '../assets/snowdrop.gif'; 
const PaymentFailPage = () => {
  const navigate = useNavigate();
  const reason = 'خطا در اتصال به بانک یا لغو توسط کاربر';

  return (
    <div className="container mt-5 text-center">
      <div className="card shadow-sm">
        <div className="card-body">
          <img src={snowdrop} alt="گیاه ناراحت" className="mb-4" style={{ width: '150px' }} />
          
          <h1 className="card-title text-danger mb-4">پرداخت ناموفق بود ❌</h1>
          <p className="text-muted mb-3">دلیل: {reason}</p>
          <p className="text-muted mb-4">در صورت تمایل، می‌توانید دوباره تلاش کنید.</p>
          <button
            onClick={() => navigate('/plans')}
            className="btn btn-danger btn-lg"
          >
            تلاش مجدد برای پرداخت
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailPage;
